var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.8125 6.90625L13.0634 6.15719L9.03125 10.1841V0H7.96875V10.1841L3.93656 6.15719L3.1875 6.90625L8.5 12.2188L13.8125 6.90625Z","fill":"#031E44","key":0}),React.createElement("path",{"d":"M15.5833 12.9524V15.1111H1.41667V12.9524H0V15.1111C0 15.3974 0.149256 15.6719 0.414932 15.8743C0.680609 16.0768 1.04094 16.1905 1.41667 16.1905H15.5833C15.9591 16.1905 16.3194 16.0768 16.5851 15.8743C16.8507 15.6719 17 15.3974 17 15.1111V12.9524H15.5833Z","fill":"#031E44","key":1})]);
}

Download.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Download;

Download.default = Download;
